function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconB2BComplete = function SvgIconB2BComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M270.8 147.329a16 16 0 1 0 16 16 16.018 16.018 0 0 0-16-16Zm0 29.693a13.693 13.693 0 1 1 13.7-13.693 13.709 13.709 0 0 1-13.7 13.693Z",
    transform: "translate(-254.802 -147.329)",
    style: {
      fill: "#00c948"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.182 169.93-7.163 7.163-4.5-4.5-1.993 1.993 6.49 6.49 1.993-1.993 7.163-7.163Z",
    transform: "translate(-264.352 -159.504)",
    style: {
      fill: "#00c948"
    }
  }));
};
export default SvgIconB2BComplete;